import { useTopicLevelTwoTimeline } from '@op/pages/Summary/hooks/useTimelineData';
import React, { useMemo, useRef, useState } from 'react';
import { ConfigProvider, Table } from 'tea-component';
import TopicAnalysis from './TopicAnalysis';
import { LanguageType } from '@op/types/common';
import CardCommon from '@op/components/CardCommon';
import SvgIcon from '@home/components/SvgIcon';
import { getLocale, useIntl } from 'umi';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import { getTeaLocale } from '@home/utils/lang';
import { NO_DATE } from '@op/constants';
import './index.scss';
import useTopicTrackingTableColumns from '../hooks/topicTracking';
import { getLanguage } from '@home/utils/common';
import { LANGUAGE_EN } from '@home/_config/config';
const { expandable, pageable, sortable, scrollable, autotip } = Table.addons;

export default function TopicLevelOneTable({
  topicLevelList,
  filter,
  transTopic,
  language,
  loading,
  // goToFeeds,
  topicTitleEn,
  topicTitleCn,
  icon,
  sentimentType,
}: {
  topicLevelList: Array<any>;
  filter: any;
  transTopic: any;
  language: LanguageType;
  loading: boolean;
  // goToFeeds: any;
  topicTitleEn: string;
  topicTitleCn: string;
  icon: string;
  sentimentType: string;
}) {
  const { locale: localLang, formatMessage } = useIntl(); // 中英切换方法
  const isEn = localLang === LANGUAGE_EN;

  // 当前展开的产品
  const [expandedKeys, setExpandedKeys] = useState([]);
  const stopRef = useRef(false);

  // 批量请求图表数据
  const {
    timelineMap,
  } = useTopicLevelTwoTimeline({
    filter,
    topicLevel: 'L1',
  });

  const { columns, sortList, sort, setSort } = useTopicTrackingTableColumns({
    timelineMap,
    filter,
    transTopic,
    topicLevel: 'L1',
  });

  const records = useMemo(() => {
    const list = topicLevelList?.sort(sortable.comparer([sort])) || [];
    return list;
  }, [topicLevelList, sort]);

  const locale = getTeaLocale(getLocale());

  function getTableAddons() {
    const addons = [
      sortable({
        columns: sortList.map((item) => ({ prefer: 'desc', key: item })),
        value: [sort],
        onChange: (value) => {
          const sort: any = value?.[0] || {
            by: 'mentions',
            order: 'desc',
          };
          buriedBtnPoint('STO_ListRank', sort.by);
          setSort(sort);
        },
      }),
      scrollable({
        minWidth: 1156,
      }),
      autotip({
        emptyText: formatMessage({ id: NO_DATE.SELECTION }),
      }),
      expandable({
        expandedKeys,
        onExpandedKeysChange: (keys, { operateKey, operateType }) => {
          if (stopRef.current) return;

          if (operateType === 'expand') {
            buriedBtnPoint('STO_TopicOpenList', operateKey);
          }
          setExpandedKeys(keys);
        },
        rowExpand: true,
        render(record) {
          const topics = record.child_topics;

          return (
            <TopicAnalysis
              transTopic={transTopic}
              filter={filter}
              topics={topics}
              language={language}
              topicLevel="L1"
              // goToFeeds={goToFeeds}
              currentTopic={record.topic}
              sentimentType={sentimentType}
            ></TopicAnalysis>
          );
        },
      }),
    ];

    if (records.length > 10) {
      addons.push(pageable());
    }
    return addons;
  }

  return (
    <CardCommon contentCard loading={loading} loadingHeight={250}>
      <ConfigProvider locale={locale}>
        <Table
          className="dbo-topic-tracking-table"
          bordered="all"
          records={records}
          recordKey={'topic'}
          columns={[
            {
              key: 'keyTopics',
              header: (
                <div className="dbo-topic-tracking-table-header-with-icon">
                  <SvgIcon type={icon} style={{ marginRight: '8px' }} />
                  {getLanguage(isEn, topicTitleEn, topicTitleCn)}
                </div>
              ),
              width: 223,
              render: (record) => (
                <div className="dbo-topic-tracking-table-title">
                  <div className="dbo-topic-tracking-table-topic">
                    {`${transTopic(record.topic, 'L1') 
                    } (${record.child_topics.length})`}
                  </div>
                  {/* <Bubble
                    dark={true}
                    content={formatMessage({ id: 'Go to Feeds' })}
                  >
                    <div style={{ display: 'inline-block' }}>
                      <SvgIcon
                        type="view-details-icon"
                        onClick={() => {
                          goToFeeds(record.topic, 'L1');
                          buriedBtnPoint('STO_TopicGoFeeds', record.topic);
                          stopRef.current = true;
                        }}
                      />
                    </div>
                  </Bubble> */}
                </div>
              ),
            },
            ...columns,
          ]}
          addons={getTableAddons()}
        />
      </ConfigProvider>
    </CardCommon>
  );
}
